import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class InternalLoginUrlService {
  isVanityEnabled(): boolean {
    return environment.enableVanityInternalLogin;
  }

  getLoginPath(): string {
    return this.isVanityEnabled() ? '/internal/user/login' : '/user/login';
  }

  getSessionTimeoutPath(): string {
    return this.isVanityEnabled() ? '/internal/user/session-time-out' : '/user/session-time-out';
  }

  isInternalUrl(url: string): boolean {
    const internalUrl = this.isVanityEnabled() ? environment.internalUrl : environment.legacyInternalUrl;
    return Boolean(url && internalUrl && url.includes(internalUrl));
  }

  isBlockedHost(hostname: string): boolean {
    return this.isVanityEnabled() && environment.blockedHosts.includes(hostname);
  }
}
